module.exports = __webpack_public_path__ + "img/图片15.fe3ceba2.png";